export enum DataType {
    SINGLE_LINE_TEXT = 'SingleLine.Text',
    SINGLE_LINE_TEXT_AREA = 'SingleLine.TextArea',
    SINGLE_LINE_EMAIL = 'SingleLine.Email',
    SINGLE_LINE_PHONE = 'SingleLine.Phone',
    SINGLE_LINE_URL = 'SingleLine.URL',
    MULTIPLE = 'Multiple',
    WHOLE_NONE = 'Whole.None',
    DECIMAL = 'Decimal',
    FP = 'FP',
    DATE_AND_TIME_DATE_AND_TIME = 'DateAndTime.DateAndTime',
    DATE_AND_TIME_DATE_ONLY = 'DateAndTime.DateOnly',
    CURRENCY = 'Currency',
    OPTIONSET = 'OptionSet',
    MULTI_SELECT_OPTIONSET = 'MultiSelectPicklist',
    TWO_OPTIONS = 'TwoOptions',
    LOOKUP_SIMPLE = 'Lookup.Simple',
    LOOKUP_OWNER = 'Lookup.Owner',
    LOOKUP_CUSTOMER = 'Lookup.Customer',
    // Not supported in pcf dataset - https://learn.microsoft.com/en-us/power-apps/developer/component-framework/manifest-schema-reference/property-set#value-elements-that-are-not-supported
    WHOLE_LANGUAGE = 'Whole.Language',
    WHOLE_DURATION = 'Whole.Duration',
    WHOLE_TIMEZONE = 'Whole.TimeZone',
    FILE = 'File',
    IMAGE = 'Image',
  }